import React from 'react';
import styled from 'styled-components';
import ScrollLock from 'react-scrolllock';
import PropTypes from 'prop-types';

import Cross from '../../images/icon-cross.inline.svg';
import Logo from '../../images/logo-car.inline.svg';
import { Map } from './Map';
import { PALE_GREY } from '../../theme';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${PALE_GREY};
  //to overcome z-index: 10000 of the header
  z-index: 20000;
`;

const Close = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  box-shadow: 0 -1px 1px 0 rgba(0, 0, 0, 0.02), 0 2px 4px 0 rgba(155, 132, 135, 0.06), 0 4px 12px 0 rgba(119, 94, 98, 0.05);
  background-color: #ffffff;
  z-index: 1;
  padding: 8px;
  border: none;
`;

const StyledCross = styled(Cross)`
  width: 24px;
  height: 24px;
  fill: #354354;
`;

const StyledLogo = styled(Logo)`
  width: 56px;
  height: 56px;
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 1;
`;

const MapContainer = styled.div`
  width: 100%;
  height: 100%;
`;

const MapModalWindow = (props) => {
  const {
    updateExamCentersByCoordinates, examCentersData, toggleMapPopup,
  } = props;

  return (
    <ScrollLock>
      <Overlay>
        <Close type="button" onClick={toggleMapPopup}><StyledCross /></Close>
        <StyledLogo />
        <MapContainer id="mobile-map-container">
          <Map
            updateExamCentersByCoordinates={updateExamCentersByCoordinates}
            examCentersData={examCentersData}
            isMobileView
          />
        </MapContainer>
      </Overlay>
    </ScrollLock>
  );
};

MapModalWindow.propTypes = {
  updateExamCentersByCoordinates: PropTypes.func.isRequired,
  examCentersData: PropTypes.array.isRequired,
  toggleMapPopup: PropTypes.func.isRequired,
};

export { MapModalWindow };
